"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Button_1 = require("../button/Button");
const { root: buttonRoot } = Button_1.buttonClasses;
const MuiDialogActionsOverrides = {
    MuiDialogActions: {
        styleOverrides: {
            root: {
                paddingLeft: '24px',
                paddingRight: '24px',
                paddingBottom: '24px',
                paddingTop: '16px',
                [`& > .${buttonRoot}:last-child`]: {
                    marginLeft: '16px'
                }
            },
        },
    },
};
exports.default = MuiDialogActionsOverrides;
//# sourceMappingURL=MuiDialogActionsOverrides.js.map